import twire from './twire';

export default (Alpine) => {
	
	Alpine.directive('scroll-to', (el, { expression }) => {

		var $el = $(el);

		$el.addClass('is-initialised');

		$el.on('click', (e) => {

			e.preventDefault();
		
			twire.util.scrollTo(expression, 'header nav');
	
		});

	});

};